import { useItemSet } from '@exam-management/common/item-set-provider';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { EDITABLE_ITEM_SET_QUESTION_DETAILS_STATUSES } from '@exam-management/qcontent-management';
import { Flex, FormButton } from '@shared/components';
import { useHasPermission } from '@shared/permissions';

export default function ItemSetSubQuestionEditFormActions() {
  const { itemSet } = useItemSet();
  const hasUpdatePermission = useHasPermission(APP_PERMISSIONS.QBANK.QUESTION.UPDATE);

  const isEditableByStatus = EDITABLE_ITEM_SET_QUESTION_DETAILS_STATUSES.includes(itemSet.status);
  const isEditable = isEditableByStatus && hasUpdatePermission;

  if (!isEditable) return null;

  return (
    <Flex sx={{ gap: (theme) => theme.spacing(4) }}>
      <FormButton type='submit' label='Save' />
    </Flex>
  );
}
